import {getVersion,buildFilterParams} from "../helpers";
import {GetClientType} from '../config'

const ApiRouts = {
    PROFILE: `${getVersion()}/profile`,
    SIGN_IN: "login",
    API_LATEST_VERSION: `${getVersion()}/${GetClientType()}/version`,
    API_DRAWER_MENU: `${getVersion()}/${GetClientType()}/categories`,
    API_BANNER: `${getVersion()}/${GetClientType()}/categories/banners`,
    API_COLOR_LIST: `${getVersion()}/${GetClientType()}/colors`,
    API_SPACE_LIST: `${getVersion()}/${GetClientType()}/spaces`,
    API_TOTAL_COUNT_LIST: `${getVersion()}/${GetClientType()}/category-data?with[]=files`,
    API_PRODUCT_MODAL_DATA: `${getVersion()}/${GetClientType()}/files`,
    API_COLLECTION_MODAL_DATA: `${getVersion()}/${GetClientType()}/collections`,
    // API_SHOW_MORE_PRODUCT: `${getVersion()}/${GetClientType()}/categories/files`,
    API_LICENCE: `sync-user-license`,
    API_LIKE: `${getVersion()}/${GetClientType()}/user-favorites/file`,
    API_LIKE_Collection: `${getVersion()}/${GetClientType()}/user-favorites/collection`,
    API_SIGN_UP: `register`,
    API_SIGN_IN: `login`,
    API_SINGLE_COLLECTION: `${getVersion()}/${GetClientType()}/collections`,
    API_GET_PROFILE: `${getVersion()}/profile`,
    API_PRODUCT_LIST: (params) => {
        const base = `${getVersion()}/${GetClientType()}/category-data`
        const productUrl = `${base}${params?.selectedId ? `/${params?.selectedId}/?` : '/?'}`;
        const filterParams = buildFilterParams(params);
        return `${productUrl}with[]=files&with[]=collections&${filterParams}`;
    },
    API_SHOW_MORE_COLLECTION: (params) => {
        const base = `${getVersion()}/${GetClientType()}/categories/collections`
        const collectionUrl = `${base}${params?.selectedId ? `/${params.selectedId}/?` : '/?'}`;
        const filterParams = buildFilterParams(params);
        return `${collectionUrl}page=${params.page}&${filterParams}`;
    },
    API_SHOW_MORE_PRODUCT: (params) => {
        const base = `${getVersion()}/${GetClientType()}/categories/files`
        const collectionUrl = `${base}${params?.selectedId ? `/${params.selectedId}/?` : '/?'}`;
        const filterParams = buildFilterParams(params);
        return `${collectionUrl}page=${params.page}&${filterParams}`;
    },
    API_FAVORITE_FILES:(params) => {
        const base = `${getVersion()}/${GetClientType()}/user-favorites/files`
        const filterParams = buildFilterParams(params);
        return `${base}/?page=${params.page}&${filterParams}`;
    },
    API_FAVORITE_COLLECTION:(params) => {
        const base = `${getVersion()}/${GetClientType()}/user-favorites/collections`
        const filterParams = buildFilterParams(params);
        return `${base}/?page=${params.page}&${filterParams}`;
    },
    API_ACTIVE_LICENSE: `set-user-license`,
    API_FORGET_PASSWORD: `forget-password`,

}

export default ApiRouts
